module.exports = __webpack_public_path__ + "9d4b616e12fd79e0c356790889e4b055.png";